import type { ReactNode } from 'react';

export const isBlankValue = (value: ReactNode) =>
  value === null || value === undefined || value === '' || value === false;
